<template>
</template>

<script>
  import {mapActions} from 'vuex'
  import {Loading} from 'element-ui'

  export default {
    name: 'logout',
    methods: {
      ...mapActions('Auth', ['doLogout']),
      ...mapActions(['emptyAll'])
    },
    async mounted() {
      let loadingInstance = Loading.service({ fullscreen: true });
      await this.doLogout()
      await this.emptyAll()
      loadingInstance.close()
      this.$router.push({name: 'auth.index'})
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Auth/logout.vue